import { combineReducers } from 'redux';
import sms from './auth/sms';
import status from './auth/status';
import bankPayment from './bankPayment';
// import defaultState from './default';
import brand from './brand';
import guidedChoice from './guidedChoice';
import huggg from './huggg';
import hugggs from './hugggs';
import pin4 from './pin4';
import prepaidCard from './prepaidCard';
import product from './product';
import reaction from './reaction';
import redeem from './redeem';
import selectedSegment from './selectedSegment';
import stash from './stash';
import tillo from './tillo';
import voucher from './voucher';

export default combineReducers({
  auth: combineReducers({ status, sms }),
  brand,
  huggg,
  hugggs,
  pin4,
  redeem,
  stash,
  tillo,
  voucher,
  reaction,
  guidedChoice,
  prepaidCard,
  bankPayment,
  selectedSegment,
  product,
});
